import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import InputField from '@medflex/components/stories/InputField';
import { gdtConstants } from '@medflex/gdt';

const { GdtFeatures } = gdtConstants;

const SettingsInputField = ({ feature, fieldKey, register, defaultValue, error }) => {
  const { t } = useTranslation('physician', { keyPrefix: 'PVSIntegrationModule' });

  return (
    <div className="mb-5">
      <label htmlFor={fieldKey} className="font-semibold mb-2">
        {t(`${feature}.${fieldKey}.label`)}
      </label>
      <InputField
        ref={register}
        id={fieldKey}
        className="w-full"
        type="text"
        name={fieldKey}
        placeholder={t(`${feature}.${fieldKey}.placeholder`)}
        defaultValue={defaultValue}
      />
      {error && <p className="text-red-500 text-sm">{t(`${feature}.${fieldKey}.error`)}</p>}
    </div>
  );
};

SettingsInputField.propTypes = {
  feature: PropTypes.oneOf([
    GdtFeatures.SYNC_PATIENTS,
    GdtFeatures.OPEN_PATIENT_IN_PVS,
    GdtFeatures.OPEN_PATIENT_IN_MEDFLEX,
    GdtFeatures.WRITE_EXAMINATION,
  ]).isRequired,
  fieldKey: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  error: PropTypes.object,
};

export default SettingsInputField;
